/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Createdat1Inputs */

const de__field_createdat1 = /** @type {(inputs: _Field_Createdat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`angelegt am`)
};

/**

* @param {_Field_Createdat1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_createdat1 = /** @type {((inputs?: _Field_Createdat1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Createdat1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_createdat1(inputs)
});
export { _field_createdat1 as "_field_createdAt" }